import React, { HTMLTableRow, useEffect, useRef } from "react";
import { Table, TableRow, TableCell, RootRef } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";

/*
 * TODO: Will likely move into component-library after changing overall page layout in next card but want to keep them in here for now
 *  in case I need to make additional changes for size
 */

export const StyledTableRow = withStyles(theme => ({
  root: {
    color: "#000000",
    height: "64px",
    backgroundColor: "#FFFFFF",
    "&:nth-of-type(even)": {
      backgroundColor: "#FAFAFA"
    }
  }
}))(TableRow);

export const StyledTableCell = withStyles(theme => ({
  body: {
    border: "1px solid #DADCE0",
    fontSize: "16px",
    lineHeight: "21.1px",
    fontFamily: "Roboto Mono",
    padding: "21px",
    color: "inherit"
  }
}))(TableCell);

export const StyledTableHeaderCell = withStyles(theme => ({
  head: {
    backgroundColor: "#FAFAFA",
    color: "#000000",
    fontFamily: "Work Sans",
    fontWeight: 600,
    paddingLeft: "24px",
    paddingTop: "25px",
    paddingBottom: "25px",
    paddingRight: "40px",
    border: "1px solid #DADCE0",
    lineHeight: "14.08px",
    fontSize: "12px",
    textTransform: "uppercase",
    position: "sticky",
    alignSelf: "flex-start",
    top: 0
  }
}))(TableCell);

export const StyledTable = withStyles(theme => ({
  root: {
    boxShadow: "0px 10px 20px rgba(173, 174, 174, 0.25)",
    borderRadius: "8px",
    "overflow-y": "auto",
    borderCollapse: "separate"
  }
}))(Table);

export const StyledCurrentRow = props => {
  useEffect(() => {
    const row = document.getElementById("current-period");
    if (row) {
      row.scrollIntoView(true);
      const table = row.parentElement.parentElement.parentElement.parentElement;
      table.scrollTop = table.scrollTop - row.offsetHeight;
    }
  }, []);

  return (
    <StyledTableRow style={{ backgroundColor: "#0F9AD6", color: "#FFFFFF" }} id="current-period">
      {props.children}
    </StyledTableRow>
  );
};

export const StyledCashFlowTableRow = props => {
  const row = (
    <StyledTableRow>
      {props.children}
    </StyledTableRow>);
  if (props.isCurrent) {
    return (
      <StyledCurrentRow>
        {props.children}
      </StyledCurrentRow>
    );
  }

  return row;
};
